<template>
  <div>
        <a-tabs type="card" :activeKey='activeKey' @change='changeTabs'>
          <a-tab-pane key="1" tab="全部订单"></a-tab-pane>
          <a-tab-pane key="40" tab="未完成"></a-tab-pane>
          <a-tab-pane key="50" tab="已出票"></a-tab-pane>
          <a-tab-pane key="90" tab="已退票"></a-tab-pane>
          <a-tab-pane key="60" tab="已失败"></a-tab-pane>
          <a-tab-pane key="666">
            <template #tab>
              <div class='robtab'>抢票单</div>
            </template>
          </a-tab-pane>
          <!-- <a-tab-pane key="6" tab="抢票单"></a-tab-pane>  暂时没有抢票单-->
        </a-tabs>
        <!-- 选择日期 -->
        <div class="chooseDate">
          <div>
            <img src="@assets/img/calendar2.png" />
            <a-range-picker
              v-model:value="pickerDate"
              separator="至"
              valueFormat='YYYY-MM-DD'
              @change="dateChange"
            />
          </div>

          <div v-if='activeKey == 50' class='radio_content' @click='changeisEffective()'>
            <df-radio :checked='isEffective' ></df-radio> <span>有效订单</span>
          </div>


            <div>
                <a-input v-model:value="orderCode" placeholder="订单号" @change="dateChange"/>
            </div>

        </div>
        <!--  -->
        <a-spin :spinning="loadingTag">
          <div class="order-list">
            <div class="item" v-for="(item, index) in orderList" :key="index" @click='toDetail(item)'>
              <a-row class="item-top">
                <a-col :span="12">订单号：{{item.orderCode}}</a-col>
                <a-col :span="12" class='regular' v-if='activeKey != 666'>预订时间：{{item.passengersList?item.passengersList[0].createTime:''}}</a-col>
                <a-col :span="12" class='regular' v-if='activeKey == 666'>创建时间：{{item.createTime}}</a-col>
                <!-- 预订时间：2020-11-11 20:01:03 预定时间暂时没有-->
              </a-row>
              <a-row class="item-content">
                <a-col :span="10" class="item-left">
                  <a-row class="train-card">
                    <a-col :span="8" class='regular'>
                      <div class="city">{{item.fromStation}}</div>
                      <div class="time" v-if='activeKey != 666'>{{item.fromTime}}</div>
                    </a-col>
                    <a-col :span="8" class="middle">
                      <div class='line_content'>
                        <span v-if='activeKey != 666'>{{item.trainNo}}</span>
                        <img src="@assets/img/idcard.png" class='idcard' v-if='activeKey != 666'/>
                      </div>
                      <img src="@assets/img/cardline.png" />
                      <div v-if='activeKey != 666'>{{item.takeTimeFormat}}</div>
                    </a-col>
                    <a-col :span="8" class="right regular">
                      <div class="city">{{item.toStation}}</div>
                      <div class="time" v-if='activeKey != 666'>{{item.toTime}}</div>
                    </a-col>
                  </a-row>
                </a-col>
                <a-col :span="14" class="item-right" v-if='activeKey != 666'>
                  <div>车票数量：{{ item.passengerCount }}张 {{item.passengerNameFirst}}</div>
                </a-col>
              </a-row>
              <a-row v-if='activeKey == 666 && item.chooseDates'>
                备选日期：{{item.chooseDates.split('|').join('，')}}
              </a-row>
              <a-row class="item-bottom">
                <a-col :span="12" v-if='activeKey != 666'>发车时间：{{item.fromTimeFormat}}</a-col>
                <a-col :span="12" v-if='activeKey == 666'>出行乘客：{{item.rushTicketOrderPassengersBoList?extract(item):''}}</a-col>
                <a-col :span="12" class="bottom-right" v-if='activeKey != 666'>
                  <span class="tag tag1" 
                      v-if="
                        item.orderState === 10 ||
                        item.orderState === 20 ||
                        item.orderState === 40
                      "
                    >{{ item.orderStateValue }}
                  </span>
                   <span class="tag tag6" 
                      v-if="item.orderState === 30"
                    >{{ item.orderStateValue }}
                  </span>
                   <span class="tag tag3" 
                      v-if="item.orderState === 60"
                    >{{ item.orderStateValue }}
                  </span>
                   <span class="tag tag4" 
                      v-if="item.orderState === 90"
                    >{{ item.orderStateValue }}
                  </span>
                   <span class="tag tag5" 
                      v-if="item.orderState === 50"
                    >{{ item.orderStateValue }}
                  </span>
                </a-col>

                <a-col :span="12" class="bottom-right" v-if='activeKey == 666'>
                  <span class="tag tagfull" 
                      v-if="
                        item.state === 20
                      
                      "
                    >{{ item.stateVal }}
                  </span>
                   <span class="tag failure" 
                      v-if="item.state === 90"
                    >{{ item.stateVal }}
                  </span>

                   <span class="tag tag3" 
                      v-if="item.state === 80"
                    >{{ item.stateVal }}
                  </span>
             
                  <span class="tag tag6" 
                      v-if="item.state === 30"
                    >{{ item.stateVal }}
                  </span>
                </a-col>
              </a-row>
            </div>
          
          <!-- 分页 -->
          </div>
          <a-empty :description="'～暂无订单～'" v-show='!orderList.length && !loadingTag' style='margin-top:200px'/>
          <a-pagination 
            v-show='orderList.length'
            v-model:current="current" 
            :total="total" 
            :page-size='8'
            @change='pageChange'
            :show-total="(total, range) => `第${range[0]}条 - 第${range[1]}条  共 ${total} 条`"
          
            />
        </a-spin>
       

  </div>
</template>
<script>
import { ref, watch } from 'vue'
import commonApi from '@axios/common'
import { useRouter, useRoute } from 'vue-router'
import homeApi from '@axios/home'

export default {
  name: 'orderList',
  components: {

  },
  setup () {
    let router = useRouter()
    const route = useRoute()
    
    // 乘客信息
    let passengerChecked = ref(false)
    const passengerChange = (e) => {
      console.log(e.target.checked)
    }
    // 日期
    let pickerDate = ref([])
      let orderCode = ref('');
    const dateChange = (date) => {
      getOrderList()
    }

    // 分页
    
    let activeKey = ref('1')
    const changeTabs = (tab) => {
      if(loadingTag.value) return;
      activeKey.value = tab;
      getOrderList();
    }

    let loadingTag = ref(false);
    let isEffective = ref(false);

    let orderList = ref([]);

    let current = ref(1);
    let total = ref(0);

    let dataStart = '';
    let dataEnd = '';

    const getOrderList = () => {
      
      if(loadingTag.value){
        return;
      }

      let params = {
        size: 8,
        currentPage: current.value
      }
   
      if(activeKey.value != '1'){
        if(activeKey.value == '90'){
          params.returnState = 10
        }else{
          params.orderState = activeKey.value
        }
      }

      if(activeKey.value == 50){
        params.isEffective = isEffective.value
      }
      
      if(pickerDate.value.length){
        params.orderBeginTime = pickerDate.value[0]
        params.orderEndTime = pickerDate.value[1]
      }

        if(orderCode.value != ''){
            //console.log("orderCode>>>>" + orderCode)
            params.orderCode = orderCode.value
        }

      loadingTag.value = true;

      if(params.orderState == '666'){
        //去抢票列表 老哥

        robOrderList(params)
        return;
      }

      homeApi.getOrderList(params).then((res) => {
        orderList.value = res.data;
        current.value = res.page;
        total.value = res.total;
        loadingTag.value = false
      }).catch(()=>{
        loadingTag.value = false
      })
    }

    const robOrderList = (p) => {
      homeApi.robOrderList(p).then((res)=>{
        loadingTag.value = false
        orderList.value = res.data;
        current.value = res.page;
        total.value = res.total;
        
      }).catch(()=>{
        loadingTag.value = false
      })
    }

  
    const pageChange = (page) => {
      current.value = page;
      getOrderList();
    }

    getOrderList();
    
    const changeisEffective = () => {
      isEffective.value = !isEffective.value;
      current.value = 1;
      getOrderList();
    }

    const toDetail = (item) => {

      if (item.type == 20 && item.orderState != 50) {
        router.push({
          name: 'endorsed',
          query: {
            orderCode: item.orderCode
          }
        })

        return
      }

      if(item.chooseDates){
        router.push({
          name: 'robDetail',
          query: {
            code: item.orderCode
          }
        })
        return
      }


      router.push({
        name: 'orderDetail',
        query: {
          orderCode: item.orderCode
        }
      })
    }

    const extract = (item) => {
      let arr = item.rushTicketOrderPassengersBoList.map((ele)=>{
        return ele.passengerName
      })
      return arr.join('，')
    }

    return {
      extract,
      toDetail,
      isEffective,
      changeisEffective,
      pageChange,
      total,
      orderList,
      loadingTag,
      activeKey,
      changeTabs,
      passengerChecked,
      passengerChange,
      pickerDate,
      dateChange,
      current,
        orderCode


    }
  },

}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.robtab{
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  text-decoration: underline;
}
.regular{

  font-family: PingFangSC-Regular, PingFang SC;
}
.line_content{
  display: flex;
  justify-content: center;
  align-items: center;

}
.idcard{
  width: 17px;

  margin-left: 10px;
  position: relative;
  top:-1px;
}
.radio_content{
  display: flex;
  align-items: center;
  cursor: pointer;
  span{
    margin-left: 10px;
    color:#848484;
    font-family: PingFangSC-Regular, PingFang SC;
    font-size: 14px;
  }
}
.topTitle {
  line-height: 20px;
  margin-bottom: 20px;
  span {
    margin: 0 2px;
  }
}
.chooseDate {
  display: flex;
  justify-content: space-between;
  img {
    width: 20px;
    margin-right: 10px;
    vertical-align: middle;
  }
  .ant-calendar-picker {
    width: 216px;
  }
}
.order-list {
  margin-top: 13px;
  .item {
    padding: 13px 18px;
    border: 0.5px solid #dbdce0;
    margin-bottom: 20px;
    cursor: pointer;
    .item-top {
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 10px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      & .ant-col:nth-of-type(2) {
        text-align: right;
      }
    }
    .item-content {
 
      .item-left {
    
        .train-card{
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .city {
          font-size: 16px;
          line-height: 22px;
          margin-bottom: 12px;
        }
        .time {
          font-size: 16px;
          line-height: 18px;
          font-weight:600 ;
        }
        .middle {
          text-align: center;
          font-size: 12px;
          line-height: 17px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          &>img{
            width: 65px;
          }
        }
        .right {
          text-align: right;
        }
      }
      .item-right {
        text-align: right;
      }
    }
    .item-bottom {
      font-size: 14px;
      line-height: 20px;
      margin-top: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      .bottom-right {
        text-align: right;
        .tag {
          color: #0099ff;
          border: 0.5px solid #0099ff;
          border-radius: 10px;
          padding: 0px 12px;
          font-size: 14px;
          height: 22px;
          line-height: 22px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
        }
      }
    }
  }
  .ant-pagination {
    text-align: center;
    margin-top: 40px !important;
  }
}
  .tag.tag1 {
    color: #3999fb!important;
    border-color: #3999fb!important;
  }
  .tag.tag2 {
    color: #fd5739!important;
    border-color: #fd5739!important;
  }
  .tag.tag3 {
    color: #929292!important;
    border-color: #929292!important;
  }

  .tag.tag6 {
    color: red!important;
    border-color: red!important;
  }

  .tag.tag4 {
    color: #000000!important;
    border-color: #000000!important;
  }
  .tag.tag5 {
    color: #00b54f!important;
    border-color: #00b54f!important;
  }

  .tag.failure {
    color: #FFAB00!important;
    border-color: #FFAB00!important;
  }
  .tagfull{
    background: #FFAB00!important;
    color:#fff!important;
    border-color: #FFAB00!important;
  }
</style>
